import React from 'react';
import { Tag } from '@eb/eds-tag';
import { gettext } from '@eb/i18n';
import {
    EVENTBRITE_CATEGORY_TO_REFINEMENT,
    EVENTBRITE_FORMAT_TO_REFINEMENT,
    DATES_TO_REFINEMENT,
} from '../../../../../../constants';

import { TagGroup } from './TagGroup';

export const FilterSuggestions = (props) => {
    if (props.suggestedFilters.length < 4) {
        return null;
    }

    const handleTagClick = (filter) => {
        window.scroll(0, 0);
        const labelValues = {
            EVENTBRITE_CATEGORY_TO_REFINEMENT,
            EVENTBRITE_FORMAT_TO_REFINEMENT,
            DATES_TO_REFINEMENT,
        };

        props.handleApplyFilterSimple({ [filter.type]: filter.value });
        props.trackGAEvent({
            action: 'QuickFilter',
            label: labelValues[filter.value] || 'free',
        });
    };

    return (
        <TagGroup
            containerClassName="pivot-section suggested-filters"
            suggestedItems={props.suggestedFilters}
            headerText={gettext('Suggested filters')}
            render={(filter) => {
                return (
                    <div className="eds-l-mar-all-1" key={filter.value}>
                        <Tag
                            style="outlined"
                            onActiveToggle={() => handleTagClick(filter)}
                        >
                            {filter.display}
                        </Tag>
                    </div>
                );
            }}
        />
    );
};
